// Wrapper around process.env.NODE_ENV to make it easier to mock in tests
export default function getNodeEnv() {
  return process.env.NODE_ENV;
}
